import { PagingPanel } from '@devexpress/dx-react-grid-material-ui';
import { createElement } from 'react';

var PagingPanelContainer = function PagingPanelContainer(props) {
  return /*#__PURE__*/createElement(PagingPanel.Container, props);
};

export { PagingPanelContainer };